export default __webpack_public_path__ + "static/media/snow-active.92a07231.svg";